import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { COLORS3, FONT, SPACING, ZINDEX } from '@zola/zola-ui/src/styles/emotion';
import { inputBaseStyles } from '@zola/zola-ui/src/components/Form/form.styles';
import { RemoveIcon } from '@zola/zola-ui/src/components/SvgIcons/Remove';
import { FormCheckbox } from 'components/common/form/FinalFormV2Elements';
import OnboardStep from '@zola/zola-ui/src/components/OnboardV2/OnboardStep';

const SUGGESION_HEIGHT = '47px';

const concealScrollbars = css`
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const StyledOnboardStep = styled(OnboardStep)`
  // provide room for dropdown suggestions
  min-height: 500px;
`;

export const AutoSuggestContainer = styled.div`
  position: relative;

  .react-autosuggest__container {
    position: relative;
  }

  .react-autosuggest__suggestions-list {
    ${concealScrollbars}
    list-style-type: none;
    padding-left: 0;
  }
  .react-autosuggest__suggestions-container {
    position: absolute;
    right: 0;
    left: 0;
  }

  .react-autosuggest__suggestions-container--open {
    overflow-y: scroll;
    z-index: ${ZINDEX.middle};
    max-height: calc(${SUGGESION_HEIGHT} * 5);
    border: none;
    box-shadow: 0 1px 8px 1px rgba(0, 0, 0, 0.2);
    width: 100%;
    background-color: ${COLORS3.WHITE_100};
    text-align: left;
    color: ${COLORS3.BLACK_100};
    ${concealScrollbars}

    .react-autosuggest__suggestion {
      padding-left: ${SPACING.XS};
      cursor: pointer;
      height: ${SUGGESION_HEIGHT};
      line-height: ${SUGGESION_HEIGHT};
      &--highlighted {
        background-color: ${COLORS3.BLACK_005};
      }
    }
  }
  .react-autosuggest__input {
    position: relative;
    height: 44px;
    margin-top: ${SPACING.XS};
    ${inputBaseStyles()};

    &::placeholder {
      cursor: default;
      font-weight: ${FONT.WEIGHT.REGULAR};
    }
  }
  .autosuggest__suggestion--first {
    border-top: none !important;
  }
`;

export const SuggestionContainer = styled.div`
  padding: 0 ${SPACING.XS};
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: none;
  font-size: ${FONT.SIZE.SMALL};
  font-weight: ${FONT.WEIGHT.REGULAR};
`;

export const StyledRemoveIcon = styled(RemoveIcon)`
  position: absolute;
  right: 10px;
  bottom: 13px;
  cursor: pointer;
`;

export const StyledCheckboxField = styled(FormCheckbox)`
  margin-top: ${SPACING.S16};
`;
